import React, { memo, useMemo } from 'react'
import { PhoneInput } from 'transfix-ui/components/PhoneInput'
import { capitalize } from 'utils/capitalize'
import FallbackOptions from './FallbackOptions'
import useFallback, { IDefaultValue, DefaultKey } from './useFallback'

export interface IPhoneProps {
  id: string
  value: string
  type: DefaultKey
  onChange: (...args: any[]) => any
  defaultValue: IDefaultValue
}

const Phone: React.FunctionComponent<IPhoneProps> = memo(
  ({ defaultValue, id, onChange, type, value }) => {
    const [canFallback, fallback, changeFallback] = useFallback(
      id,
      value,
      onChange,
      defaultValue,
      type
    )
    const label = useMemo(() => `Insurance Provider ${capitalize(type)}`, [type])
    const showInput = !canFallback || fallback === false
    return (
      <div className='col-xs-12'>
        {canFallback && (
          // @ts-ignore
          <FallbackOptions id={id} label={label} value={fallback} onChange={changeFallback} />
        )}
        {showInput && (
          <div className='row collapse'>
            <div className='col-xs-8'>
              <PhoneInput
                id={id}
                label={canFallback ? undefined : label}
                placeholder='(555) 555-5555'
                value={value || ''}
                onChange={onChange}
                dataTest={id}
              />
            </div>
          </div>
        )}
      </div>
    )
  }
)

export default Phone
